import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
import { offerBullets } from '../data/content';
export function Offer() {
  return <section id="offer" className="scroll-mt-2 bg-navy px-3 py-4 sm:px-6" data-id="element-112" data-mp="17ws2s9xeyodg">
      <div className="mx-auto max-w-xl text-center" data-id="element-113" data-mp="1mmqz075erpqa">
        <p className="inline-block rounded-full bg-gold px-3 py-0.5 font-heading text-[0.66rem] font-extrabold uppercase tracking-[0.2em] text-navy sm:text-xs" data-id="element-114" data-mp="1hnw80hxaeuv3">
          Special launch offer
        </p>
        <h2 className="mt-1.5 text-[1.15rem] font-extrabold uppercase leading-tight text-white sm:text-[1.8rem]" data-id="element-115" data-mp="p0jv6zgxi1ez">
          🫁 RESPIRATORY THERAPY VISUAL ATLAS™
        </h2>
        <p className="mt-0.5 text-[0.68rem] font-bold uppercase tracking-wide text-white/80 sm:text-[0.84rem]" data-id="element-116" data-mp="yxy1455877t1">
          The Complete Visual Study System for Respiratory Therapy Students
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[240px] sm:max-w-[290px]" target="checkout" data-id="element-117" data-mp="2ad3fi6epyush" />

        <div className="mt-2 rounded-md border-2 border-gold bg-white px-3 py-2.5 text-left" data-id="element-118" data-mp="pk7h3p1borb1">
          <p className="text-center font-heading text-[0.72rem] font-extrabold uppercase tracking-wide text-navy sm:text-[0.86rem]" data-id="element-119" data-mp="pmlbrws3c1i2">
            Complete 6-in-1 System
          </p>
          <ul className="mt-1.5 grid gap-1 sm:grid-cols-2" data-id="element-120" data-mp="zgafqkwyu7t8">
            {offerBullets.map(b => <li key={b} className="flex items-start gap-1.5" data-id="element-121" data-mp="13hvz8p409kce">
                <span className="text-[0.7rem] leading-tight" aria-hidden="true" data-id="element-122" data-mp="6v0sxmhrf7hu">
                  ✅
                </span>
                <span className="text-[0.75rem] leading-tight sm:text-[0.86rem]" data-id="element-123" data-mp="bt2b857d32s9">{b}</span>
              </li>)}
          </ul>
          <p className="mt-2 text-center font-heading text-[0.78rem] font-extrabold uppercase leading-tight text-navy sm:text-[1rem]" data-id="element-124" data-mp="kkvxm89kn7pr">
            🔥 GET RESPIRATORY THERAPY VISUAL ATLAS™ TODAY —{' '}
            <span className="text-teal" data-id="element-125" data-mp="3o9z4uyscvw6u">$26.90</span>
          </p>
          <div className="mt-1.5" data-id="element-126" data-mp="3o84jjjd6a228">
            <CTAButton label="⚡ GET INSTANT ACCESS" sub="Immediate Digital Access" target="checkout" data-id="element-127" data-mp="vf7d6ftt2ebj" />
          </div>
          <p className="mt-1.5 text-center text-[0.62rem] font-bold uppercase tracking-wide sm:text-xs" data-id="element-128" data-mp="qetehoe3ggq6">
            🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}